import { createSlice } from "@reduxjs/toolkit";
import { userAuthApi } from "../services/userAuthApi";

const initialState = {
  // token: "",
  // csrf_token: "",
  user: null,
  isLoggedIn: undefined,
  isRememberMe: false,
  isSocketConnected: false,
};

export const authSlice = createSlice({
  name: "authInfo",
  initialState,
  reducers: {
    setUser: (state, actions) => {
      state.isLoggedIn = true;
      state.user = actions.payload;
    },
    setRememberMe: (state, actions) => {
      // console.log(actions.payload);
      state.isRememberMe = actions.payload === true ? true : false;
    },
    logout: (state) => {
      state.isLoggedIn = false;
      state.isSocketConnected = false;
      state.user = {};
    },
    socketConnected: (state, actions) => {
      return {
        ...state,
        isSocketConnected: true,
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        userAuthApi.endpoints.loginUser.matchFulfilled,
        (state, { payload }) => {
          state.user = payload.data;
          state.isLoggedIn = true;
        }
      )
      .addMatcher(userAuthApi.endpoints.loginUser.matchRejected, (state) => {
        state.user = null;
      });
  },
});

export const {
  setUser,
  setRememberMe,
  logout,
  socketConnected,
  setAuthInfo,
  unsetAuthInfo,
} = authSlice.actions;

export default authSlice.reducer;
